module.exports = __webpack_public_path__ + "f6655cd9db2d5a3424510bdf08c8c990.svg";